<template>
  <div>
    <ul class="voters-list">
      <li v-for="(user,index) in users" :key="index">
        <a @@click.stop :href="userProfile(user.profileUrl)">{{user.nick}}</a>
      </li>
    </ul>
    <!-- TODO: deberíamos controlar el paginado de usuarios que han dado like a un comentario -->
    <div class="voters-buttons" v-if="false">
      <i class="voters-icon disabled fal fa-chevron-left"></i>
      <i class="voters-icon fal fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    name: 'edi-comment-user-list',
    props: {
      users: Array
    },
    computed: {
      ...mapGetters([
        'userProfile'
      ])
    }
  }
</script>
